import { Parallax } from '../components';
import { ScrollContent } from '../components';

/**
 * You can register global components here
 */

const globalComponents = {
  install(Vue) {
    Vue.component(Parallax.name, Parallax);
    Vue.component(ScrollContent.name, ScrollContent);
  }
};

export default globalComponents;
